import { VegaButtonCircle, VegaCard, VegaFlex, VegaFont, VegaInput, VegaTooltip } from '@globalpayments/vega-react';

interface Props {
  searchValue: string;
  searchHeader: string;
  searchLabel: string;
  searchTooltipText: string;
  setHasTyped: (hasTyped: boolean) => void;
  setSearchValue: (searchValue: string) => void;
  clearCards: () => void;
}

const SearchBar: React.FC<Props> = ({
  searchValue,
  searchHeader,
  searchLabel,
  searchTooltipText,
  setSearchValue,
  clearCards,
  setHasTyped,
}) => {
  return (
    <VegaCard data-testid="lookup-search-panel" padding="size-24" variant="border">
      <VegaFlex direction="col" gap="size-20">
        <VegaFlex alignItems="center" gap="size-12" justifyContent="space-between">
          <VegaFont as="h2" color="text-secondary" variant="font-h5">
            {searchHeader}
          </VegaFont>
          <VegaTooltip content={searchTooltipText} maxWidth={320} placement={['left', 'bottom']} trigger="hover">
            <VegaButtonCircle
              icon="fa-solid fa-circle-info"
              label={`About ${searchHeader}`}
              showTooltip={false}
              size="small"
              variant="icon-only"
            />
          </VegaTooltip>
        </VegaFlex>
        <VegaInput
          label={searchLabel}
          maxLength={500}
          onVegaChange={(event) => {
            const nextSearchValue = event.detail;
            setSearchValue(nextSearchValue);
            setHasTyped(nextSearchValue.length > 0);
            if (!nextSearchValue) clearCards();
          }}
          prefixIcon="fa-solid fa-magnifying-glass"
          showClearIcon
          value={searchValue}
          valueUpdateTrigger="input"
        />
      </VegaFlex>
    </VegaCard>
  );
};

export default SearchBar;
